import 'jquery'
import 'jquery-migrate'
import 'bootstrap'
import 'underscore'
import 'jquery-ui'
import 'react-components/css/wrapper/jquery-ui-1.9.2.custom.min.css'
import 'jquery.cookie'
import 'brace'
import 'brace/mode/ftl'
import 'brace/mode/html'
import 'brace/mode/javascript'
import 'brace/mode/json'
import 'brace/mode/markdown'
import 'brace/mode/mysql'
import 'brace/mode/python'
import 'brace/mode/r'
import 'brace/mode/plain_text'
import 'brace/mode/properties'
import 'brace/mode/text'
import 'brace/mode/xml'
import 'brace/ext/language_tools'
import 'brace/theme/eclipse'
import 'moment'
import 'eonasdan-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'jq-edit-rangeslider'
import 'react-components/css/wrapper/JQRangeSlider.css'
import 'select2'
import 'react-components/css/wrapper/select2.css'
import 'urijs'
import 'react'
import 'react/addons'
import 'promise'


// WEBPACK FOOTER //
// ./src/main/javascript/molgenis-vendor-webpack.js